module.exports = __webpack_public_path__ + "img/7_27.6506345c.png";